<template>
    <div class="lsn-app-layout" :class="layoutClass">
        <div class="lsn-top-bar">
            <div class="lsn-top-bar-container flex items-center justify-between h-full md:container md:mx-auto select-none">
                <img
                    src="/img/logo-swisslens-white.svg"
                    alt="SwissLens"
                    class="h-5"
                >
            </div>
        </div>

        <div class="lsn-container">
            <div class="lsn-main">
                <div class="lsn-page-content">
                    <slot name="page-content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default
{
    name: 'AppLayout',

    props:
    {
        neutral:
        {
            type:    Boolean,
            default: false,
        },
    },

    data()
    {
        return {
            sideBarOpen: false,
        };
    },

    computed:
    {
        layoutClass()
        {
            return {
                'lsn-app-layout--neutral': this.neutral,
            };
        },
    },
};
</script>
